import api from '../../../services/api';

export interface WholesaleRevenueBreakdownParams {
  start_date: string;
  end_date: string;
  channel: string;
  kind: string;
  period_type: string;
}

export interface WholesaleRevenueBreakdownItem {
  date: string;
  revenue_value: number;
  profit_value: number;
}

export const fetchWholesaleRevenueBreakdown = async (
  params: WholesaleRevenueBreakdownParams
): Promise<WholesaleRevenueBreakdownItem[]> => {
  const response = await api.get('/api/wholesale/revenue_breakdown', { params });
  return response.data.revenue_breakdown;
};
